import React from 'react';
import BoardDetail from '../components/Board/BoardDetail';

const BoardDetailPage: React.FC = () => <BoardDetail />;

export default BoardDetailPage; 